import moment from 'moment';
import * as yup from 'yup';

export const REQUIRED_FIELD_MESSAGE_TEXT = 'required';

export const requiredFieldMessage = (fieldName: string): string => `${fieldName} ${REQUIRED_FIELD_MESSAGE_TEXT}`;
export const maxLengthFieldMessage = (fieldName?: string, maxLength?: number): string =>
  `${fieldName} Max length is ${maxLength}`;

export const searchFirmSchema = (applyNumericCheck?: boolean): any => {
  return yup.object().shape({
    searchText: yup.string().when([], () => {
      return applyNumericCheck
        ? yup.string().test('numeric-characters-check', 'maximum of 10 numeric characters allowed', (value) => {
            const numericCount = (value?.match(/\d/g) || []).length;
            return numericCount <= 10;
          })
        : yup.string().test('length-check', 'You must enter between 3 and 100 characters', (value) => {
            return (value && value.length >= 3 && value.length <= 100) || false;
          });
    }),
    advancedFilterInput: yup.string().test('length-check', 'You must enter between 3 and 50 characters', (value) => {
      return (value && value.length >= 3 && value.length <= 50) || false;
    }),
    fromDate: yup
      .date()
      .nullable()
      .min('0500-01-01')
      .max('2100-01-01')
      .transform((curr, orig) => (orig === '' ? null : curr))
      .typeError(() => 'Please enter valid date.'),
    toDate: yup
      .date()
      .nullable()
      .min('0500-01-01')
      .max('2100-01-01')
      .when('fromDate', {
        is: (fromDate: Date) => fromDate != null && moment(fromDate).isValid(),
        then: yup
          .date()
          .min(yup.ref('fromDate'), 'To date cannot be before the from date')
          .transform((curr, orig) => (orig === '' ? null : curr))
          .typeError(() => 'Please enter valid date.'),
        otherwise: yup
          .date()
          .transform((curr, orig) => (orig === '' ? null : curr))
          .typeError(() => 'Please enter valid date.'),
      }),
    notifyEmail: yup.string().test('is-valid-emails', function (value) {
      if (!value)
        return this.createError({
          message: 'Email field cannot be empty',
        });
      // Split the string by semicolon
      const emails = value.split(';');
      for (let email of emails) {
        email = email.trim();
        // Trim any white spaces around email
        if (!email) {
          return this.createError({
            message: 'Email cannot end with ;, Please use ; when you want to add multiple emails. ',
          });
        }
        if (!yup.string().email().isValidSync(email)) {
          return this.createError({
            message: 'Invalid Email format, @ and . characters are required.',
          });
        }
      }
      return true;
    }),
  });
};
